<app-navbar [title]="pageTitle"> </app-navbar>

<div id="loader" *ngIf="loader"><span class="spinner-border spinner-grow-lg"></span></div>

<app-tourism-briefing-filters
	userFilters="tourism-briefing"
	[statuses]="parameters.status"
	[yesno]="parameters.yesno"
	[vehicle_busTypes]="parameters.vehicle_busType"
	[vehicle_statuses]="parameters.vehicle_status"
	[categories]="parameters.category"
	[users]="parameters.users"
	(selected)="filtersSelected($event)"
></app-tourism-briefing-filters>

<app-dynamic-table
	module="tourism-events"
	[elements]="data"
	[tableRows]="tableRows"
	[linkAccess]="auth.permissionsByCode()[Permissions.VEHICLES_CALENDAR_ACCESS]"
	(filtersClicked)="filtersOpen()"
></app-dynamic-table>
